var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.prevPageType.isOc()
        ? [
            _c(
              "section",
              [
                _c(
                  "div",
                  {
                    class: [
                      {
                        actionTitle: !_vm.isSpShiryo,
                        isPc: !_vm.isSp,
                        titleOfDocumentRequest: _vm.isSpShiryo,
                      },
                    ],
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.prevPageType.isShiryo()
                            ? "パンフレット・願書請求"
                            : "オープンキャンパス予約"
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "appealText" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.prevPageType.isShiryo()
                          ? "＼ 今すぐ資料請求に進む ／"
                          : "＼ 今すぐ予約に進む ／"
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("ButtonLink", {
                  class: ["button", { isPc: !_vm.isSp }],
                  attrs: {
                    "button-url": _vm.nextPageUrl,
                    "button-text": _vm.actionCvButtonText,
                    "button-color": "colorCta",
                    "button-size": "sizeXLarge",
                    "max-width-none": "",
                  },
                  on: { "button-clicked": _vm.onClickNoSignUpLink },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              [
                _c("div", { staticClass: "appealText appealRegistration" }, [
                  _vm._v(
                    "\n        スタディサプリ会員なら次回以降カンタン" +
                      _vm._s(_vm.prevPageType.isShiryo() ? "請求" : "予約") +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("ButtonLink", {
                  class: [
                    "registerButton button js-registerButton",
                    { isPc: !_vm.isSp },
                  ],
                  attrs: {
                    "button-url": "/smp2/quipMember/register/infoInput/",
                    "button-text": _vm.registerButtonText,
                    "button-color": "colorPrimary",
                    "button-size": "sizeLarge",
                    "max-width-none": "",
                  },
                  on: {
                    "button-clicked": function ($event) {
                      return _vm.clickRegisterButton($event)
                    },
                  },
                }),
              ],
              1
            ),
          ]
        : _vm.prevPageType.isOrganic() || _vm.prevPageType.isShiryo()
        ? _c(
            "section",
            { class: ["registrationArea", { isPc: !_vm.isSp }] },
            [
              _c("LoginPageTitle", {
                staticClass: "titleRegistration",
                attrs: { "title-text": "アカウントをお持ちでない方" },
              }),
              _vm._v(" "),
              _vm.isSp
                ? _c("img", {
                    staticClass: "membershipAppealImage",
                    attrs: { src: "/rnet/images/member_appeal.png", alt: "" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ButtonLink", {
                staticClass: "registerButton js-registerButton",
                attrs: {
                  "button-url": _vm.registerLink,
                  "button-text": "新規会員登録",
                  "button-color": "colorCta",
                  "button-size": "sizeLarge",
                  "max-width-none": "",
                },
                on: {
                  "button-clicked": function ($event) {
                    return _vm.clickRegisterButton($event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }